import { getEnvironmentVariables } from '~/environment';
import { createLogger } from '~/utils/logging';

const log = createLogger('gtag');

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}

let initialized = false;

function maybeInitGtag() {
  const env = getEnvironmentVariables();

  if (!env.googleAdsId) {
    log.info('Google Ads tracking is disabled (no VITE_GOOGLE_ADS_ID)');
    return;
  }

  // Initialize dataLayer and gtag function
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', env.googleAdsId);

  // Dynamically inject the gtag.js script
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${env.googleAdsId}`;
  document.head.appendChild(script);

  initialized = true;
  log.info('Google Ads tracking initialized', { googleAdsId: env.googleAdsId });

  trackConversion('page_view');
}

export function trackEvent(eventName: string) {
  if (!initialized) {
    log.warn(`Dropping gtag event ${eventName}`);
    return;
  }
  window.gtag('event', eventName);
}

type ConversionMilestone = 'page_view' | 'login' | 'setup';

const LABEL_KEYS: Record<
  ConversionMilestone,
  'googleAdsLabelPageView' | 'googleAdsLabelLogin' | 'googleAdsLabelSetup'
> = {
  page_view: 'googleAdsLabelPageView',
  login: 'googleAdsLabelLogin',
  setup: 'googleAdsLabelSetup',
};

export function trackConversion(milestone: ConversionMilestone) {
  const env = getEnvironmentVariables();
  const label = env[LABEL_KEYS[milestone]];
  if (!initialized || !label) {
    log.warn(`Dropping gtag conversion event: ${milestone}`);
    return;
  }
  window.gtag('event', 'conversion', {
    send_to: `${env.googleAdsId}/${label}`,
  });
}

maybeInitGtag();
